import {useNavigate} from "react-router-dom";
import HeaderButton from "./HeaderButton";
import {nav} from "../../../res/dataServices/navigation";
import {formatDisplayPrice} from "../../../res/dataServices/pricing";
import useCartLoader from "../../../newStructure/cart/hooks/useCartLoader";
import useCheckoutStore from "../../../newStructure/cart/store/checkoutStore";


const CartButton = () => {

    const navigate = useNavigate();
    useCartLoader();

    const productCount = useCheckoutStore(state => state.products?.lines?.length);
    const total = useCheckoutStore(state => state.order?.GrandTotal);

    const goToCart = () => {
        navigate(nav.ROUTE_CHECKOUT);
    }

    const lineCount = productCount ?? 0;
    const subHeading = total ? formatDisplayPrice(total) : '0 Items';

    return (
        <HeaderButton
            heading="Cart"
            subHeading={subHeading}
            onClick={goToCart}
            notificationCount={lineCount}
        >
            <img alt="" src="/assets/Cart.svg"/>
        </HeaderButton>
    )
}

export default CartButton;
